<div>
  <button (click)="createNewCompany()">Create new Company</button>
  <button (click)="edit()">{{ uiState === 'edit' ? 'Cancel' : 'Edit' }}</button>

  <!-- List -->
  @if (uiState === 'list' || uiState === 'edit') {
    <div class="list">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col" sortable="CompanyId">CompanyId</th>
            @if (uiState === 'edit') {
              <th scope="col">Modify</th>
            }
            @if (uiState === 'edit') {
              <th class="deleteColumn" scope="col">X</th>
            }
          </tr>
        </thead>
        <tbody>
          <!-- | async -->
          @for (company of companies$ | async; track company) {
            <tr>
              <th scope="row">{{ company.id }}</th>
              <td>{{ company.name }}</td>
              <td>
                @if (uiState === 'edit') {
                  <button class="deleteButton" (click)="modifyCompany(company)">Modify</button>
                }
              </td>
              @if (uiState === 'edit') {
                <button class="deleteButton" (click)="deleteCompany(company)">X</button>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  <!-- Create -->
  @if (uiState === 'create' || uiState === 'modify') {
    <div class="formDiv">
      <form class="newForm" [formGroup]="form" (ngSubmit)="onSubmit()">
        <input class="formElement" placeholder="Name" type="text" formControlName="Name" />
        <button type="submit" [disabled]="!form.valid">Submit</button>
        <button type="reset" (click)="cancelNewCompany()">Cancel</button>
      </form>
    </div>
  }
</div>
